import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import {
  CONSENT_REGIONS,
  consentRequired,
  edgeCountry,
  hasAnalyticsTag,
  setConsent,
  storedConsent
} from '../../utils/analytics';

/** Consent Mode v2 banner: until it is answered, GA4 measures without cookies. */
export function CookieConsent() {
  const { t } = useTranslation();
  const lang = useLocation().pathname.split('/')[1] || 'en';
  const [open, setOpen] = useState(false);

  // Asked only where the tag runs at all — staging, localhost and account pages store
  // nothing, so there is nothing to consent to — and only where the law requires it.
  // The country has to come from the same signal Google uses for the regional default,
  // the IP address, or the two disagree: a visitor in Berlin whose laptop says
  // Asia/Tokyo would get storage denied and no way to allow it.
  useEffect(() => {
    if (!hasAnalyticsTag() || storedConsent() !== null) return;
    let live = true;
    void edgeCountry().then((country) => {
      if (!live) return;
      setOpen(country ? CONSENT_REGIONS.includes(country) : consentRequired());
    });
    return () => {
      live = false;
    };
  }, []);

  if (!open) return null;

  const answer = (granted: boolean) => {
    setConsent(granted);
    setOpen(false);
  };

  return (
    <aside className="cookie-consent" role="region" aria-label={t('site.consent.label')}>
      <div className="wrap cookie-consent-inner">
        <p className="small">
          {t('site.consent.text')}{' '}
          <Link to={`/${lang}/privacy-policy`}>{t('site.consent.privacy')}</Link>
        </p>
        <div className="cookie-consent-actions">
          <button type="button" className="button secondary compact" onClick={() => answer(false)}>
            {t('site.consent.decline')}
          </button>
          <button type="button" className="button primary compact" onClick={() => answer(true)}>
            {t('site.consent.accept')}
          </button>
        </div>
      </div>
    </aside>
  );
}
